
require('../components/components');
import 'slick-carousel';

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}